export enum ContactType {
    AltPhone = 46,
    Email = 47,
    AltEmail = 48,
    Phone = 43,
    Mobile = 117,
    WORK_PHONE_NO = 42,
    HOME_PHONE_NO = 41
  }



// WEBPACK FOOTER //
// ./src/app/shared/enums/contact-type.enum.ts